/** 额度转换抽屉（→ demo #sub-transfer；全局挂载，我的/游戏浮层等入口共用） */
export const useTransferNav = () => {
  const open = useState('transfer-drawer-open', () => false)

  const openTransfer = () => {
    open.value = true
  }

  const closeTransfer = () => {
    open.value = false
  }

  return { open, openTransfer, closeTransfer }
}
